export default "__VITE_ASSET__3750aba9__"